import { render, staticRenderFns } from "./EditCatalogModal.vue?vue&type=template&id=fcd81574&scoped=true"
import script from "./EditCatalogModal.vue?vue&type=script&lang=js"
export * from "./EditCatalogModal.vue?vue&type=script&lang=js"
import style0 from "./EditCatalogModal.vue?vue&type=style&index=0&id=fcd81574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd81574",
  null
  
)

export default component.exports